import {
  GET_ANALYTICS_ERRORS,
  LOADING_GET_ANALYTICS,
  SET_ANALYTICS,
  LOADING_GET_AGE_DEMOGRAPHICS,
  SET_AGE_DEMOGRAPHICS,
  GET_AGE_DEMOGRAPHICS_ERRORS,
  LOADING_GET_BRAND_SALES,
  SET_BRAND_SALES,
  GET_BRAND_SALES_ERRORS,
  LOADING_GET_LENS_SALES,
  SET_LENS_SALES,
  GET_LENS_SALES_ERRORS,
} from "../types";

const initialState = {
  appointment: [],
  conversion: [],
  sales: [],
  patient: [],
  recall: [],
  loading_analytics: false,
  analytics_errors: null,
  services_stats: [],
  dispensing_statistics: [],
  stock: [],
  total_dispensed: 0,
  age_demographics: { groups: [], meta: null },
  loading_age_demographics: false,
  age_demographics_errors: null,
  brand_sales: { brands: [], meta: null },
  loading_brand_sales: false,
  brand_sales_errors: null,
  lens_sales: { lenses: [], meta: null },
  loading_lens_sales: false,
  lens_sales_errors: null,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case LOADING_GET_ANALYTICS:
      return {
        ...state,
        loading_analytics: true,
        analytics_errors: null,
      };
    case GET_ANALYTICS_ERRORS:
      return {
        ...state,
        loading_update_tax: false,
        update_tax_errors: action.payload,
      };
    case LOADING_GET_AGE_DEMOGRAPHICS:
      return {
        ...state,
        loading_age_demographics: true,
        age_demographics_errors: null,
      };
    case GET_AGE_DEMOGRAPHICS_ERRORS:
      return {
        ...state,
        loading_age_demographics: false,
        age_demographics_errors: action.payload,
      };
    case SET_AGE_DEMOGRAPHICS:
      return {
        ...state,
        loading_age_demographics: false,
        age_demographics_errors: null,
        age_demographics: action.payload,
      };
    case LOADING_GET_BRAND_SALES:
      return {
        ...state,
        loading_brand_sales: true,
        brand_sales_errors: null,
      };
    case GET_BRAND_SALES_ERRORS:
      return {
        ...state,
        loading_brand_sales: false,
        brand_sales_errors: action.payload,
      };
    case SET_BRAND_SALES:
      return {
        ...state,
        loading_brand_sales: false,
        brand_sales_errors: null,
        brand_sales: action.payload,
      };
    case LOADING_GET_LENS_SALES:
      return {
        ...state,
        loading_lens_sales: true,
        lens_sales_errors: null,
      };
    case GET_LENS_SALES_ERRORS:
      return {
        ...state,
        loading_lens_sales: false,
        lens_sales_errors: action.payload,
      };
    case SET_LENS_SALES:
      return {
        ...state,
        loading_lens_sales: false,
        lens_sales_errors: null,
        lens_sales: action.payload,
      };
    case SET_ANALYTICS:
      return {
        ...state,
        loading_analytics: false,
        analytics_errors: null,
        sales: action.payload.sales,
        patient: action.payload.patient,
        appointment: action.payload.appointment,
        conversion: action.payload.conversion,
        recall: action.payload.recall,
        services_stats: action.payload.services_stats,
        dispensing_statistics: action.payload.dispensing_statistics,
        stock: action.payload.stock,
        total_dispensed: action.payload.total_dispensed,
      };

    default:
      return state;
  }
}
